export enum DICTIONARY_UUID {
  CATEGORY = "3037677a-fccc-41a3-90b4-a8ec5d43cf87",
  PARENT_CATEGORY = "d1eb2196-1989-49b2-ab6a-326aba75947f",
  ELEMENT = "152acaa2-c5b0-4933-ba44-ae8d6ed8c69f",
}
